/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { CreateEndorsementStageForm } from '@/components/forms/CreateEndorsementForm/CreateEndorsementStageForm';
import { CreateEndorsementDealForm } from '@/components/forms/CreateEndorsementForm/CreateEndorsementDealForm';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { PoliciesSelectProvider } from '@/context/policiesContext';

export const CreateEndorsementPage = () => {
	const { getFeatureFlags } = useFeatureFlagContext();
	const showCreateEndorsementAsStageForm = Boolean(getFeatureFlags('endorsements')?.active);

	return (
		<AuthenticatedPageLayout>
			<PoliciesSelectProvider>
				{showCreateEndorsementAsStageForm ? (
					<CreateEndorsementStageForm />
				) : (
					<CreateEndorsementDealForm />
				)}
			</PoliciesSelectProvider>
		</AuthenticatedPageLayout>
	);
};
